import { render } from "./MetaIdentityComponent.vue?vue&type=template&id=85e109c0&scoped=true"
import script from "./MetaIdentityComponent.js?vue&type=script&lang=js"
export * from "./MetaIdentityComponent.js?vue&type=script&lang=js"

import "./MetaIdentityComponent.scss?vue&type=style&index=0&id=85e109c0&lang=scss&scoped=true"

import exportComponent from "C:\\Program Files\\Ampps\\www\\adapter\\metahumen\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85e109c0"]])

export default __exports__